///
/// EarthBrowser
///
/// Migration v6 to v7: Add volcano view mode preference
///
/// This migration adds the volcanoViewMode field for users to toggle
/// between topographical and 3D wireframe views in the volcano focus window.
///

interface StateV6 {
	earthbrowser?: {
		volcanoViewMode?: string
	}
}

/**
 * Migration from version 6 to 7: Add volcano view mode preference
 * - Adds volcanoViewMode with default value "topographical"
 *
 * Note: Redux freezes state objects, so we must return a new object rather than mutate
 */
export function migrateV6toV7(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV6
	const oldEarthbrowser = s.earthbrowser || {}

	// Create new earthbrowser state with volcanoViewMode
	const newEarthbrowser = {
		...oldEarthbrowser,
		volcanoViewMode: oldEarthbrowser.volcanoViewMode ?? "topographical"
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
